"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5.025 6.75c-.863 0-1.575.708-1.575 1.598v7.304c0 .89.712 1.598 1.575 1.598h8.137c.864 0 1.575-.708 1.575-1.598V13.15a.24.24 0 0 1 0-.012v-2.276a.24.24 0 0 1 0-.012V8.348c0-.89-.711-1.598-1.575-1.598H5.025Zm11.212 2.53v-.932c0-1.705-1.369-3.098-3.074-3.098H5.024c-1.706 0-3.075 1.393-3.075 3.098v7.304c0 1.705 1.37 3.098 3.075 3.098h8.137c1.706 0 3.075-1.393 3.075-3.098v-.931l2.699 2.192c1.262 1.027 3.114.107 3.114-1.496V8.583c0-1.603-1.852-2.523-3.114-1.497L16.238 9.28Zm0 1.932v1.576l3.645 2.961a.41.41 0 0 0 .668-.332V8.583a.411.411 0 0 0-.668-.333l-3.645 2.962Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=VideoIcon24.js.map